export const UnarchiveIcon = () => {
    return (
        <svg
            xmlns='http://www.w3.org/2000/svg'
            width='16'
            height='16'
            viewBox='0 0 16 16'
            fill='none'
        >
            <path
                d='M8.07015 0.699143C8.06184 0.689026 8.05122 0.680843 8.03909 0.675217C8.02696 0.669589 8.01365 0.666666 8.00016 0.666666C7.98667 0.666666 7.97336 0.669589 7.96124 0.675217C7.94911 0.680843 7.93849 0.689026 7.93017 0.699143L6.6859 2.19841C6.64035 2.25343 6.68145 2.3349 6.75589 2.3349L7.3335 2.3349L7.3335 5.91536C7.3335 5.96191 7.37349 6 7.42237 6L8.57795 6C8.62683 6 8.66683 5.96191 8.66683 5.91536L8.66683 2.33595L9.24444 2.33595C9.31887 2.33595 9.35998 2.25448 9.31443 2.19947L8.07015 0.699143Z'
                fill='#252129'
                fillOpacity='0.88'
            />
            <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M6.00016 2.08154H4.39429C4.12867 2.08154 3.89273 2.25811 3.81773 2.51279L2.17867 6.92217L2.17398 6.93311L2.17085 6.94561C2.15054 7.02217 2.14429 7.10029 2.15523 7.17686C2.15367 7.20185 2.1521 7.22686 2.1521 7.25186V12.969C2.15252 13.2209 2.25274 13.4623 2.43081 13.6403C2.60888 13.8184 2.85027 13.9186 3.1021 13.919H12.9021C13.4255 13.919 13.8521 13.4925 13.8537 12.969V7.25186C13.8537 7.23154 13.8537 7.21123 13.8521 7.19404C13.8584 7.11748 13.8521 7.04404 13.8318 6.97373L13.8287 6.96123L12.0755 2.50654C11.9974 2.25498 11.7646 2.08154 11.5005 2.08154H10.0002V3.28154H11.0662L12.3427 6.30186H9.20992L9.20523 6.54717C9.19273 7.24873 8.70835 7.72061 8.00054 7.72061C7.65523 7.72061 7.35835 7.60967 7.14429 7.39873C6.93023 7.18779 6.81304 6.89404 6.80679 6.54717L6.8021 6.30186H3.58648L4.82867 3.28154H6.00016V2.08154ZM5.80835 7.50186H3.35054V12.719H12.6505V7.50186H10.2052C10.0302 7.91123 9.75992 8.25185 9.41304 8.49561C9.01773 8.77373 8.52867 8.92061 8.0021 8.92061C6.99585 8.92061 6.18804 8.39404 5.80835 7.50186Z'
                fill='#252129'
                fillOpacity='0.88'
            />
        </svg>
    );
};
